module.exports = __webpack_public_path__ + "img/teacher_7.f273741b.png";